module.exports = __webpack_public_path__ + "static/media/robot.a20ca8ab.svg";